import { render, staticRenderFns } from "./homeSwitch.vue?vue&type=template&id=4fc9c76a"
import script from "./homeSwitch.vue?vue&type=script&lang=js"
export * from "./homeSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports